import { XmaxSdkError } from '../shared/sdk-error'

export const RTC_TEARDOWN_TIMEOUT_MS = 5_000

export async function withRtcTeardownTimeout<T>(
  operation: () => T | Promise<T>,
  stage: string,
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined
  try {
    return await Promise.race([
      Promise.resolve().then(operation),
      new Promise<never>((_, reject) => {
        timer = setTimeout(() => {
          const error = new XmaxSdkError('WEB_RTC_ERROR', `RTC teardown timed out: ${stage}`)
          error.name = 'RtcTeardownTimeoutError'
          reject(error)
        }, RTC_TEARDOWN_TIMEOUT_MS)
      }),
    ])
  } finally {
    clearTimeout(timer)
  }
}
